import React from 'react';
import PropTypes from 'prop-types';

import {Button, Typography, TextField, Dialog, DialogActions, DialogContent, DialogTitle} from 'views/components';
import {Translate, translate} from 'views/module';

const CancelEvent = (props) => {
  const {closeModel, event, onCancelEvent} = props;
  const [isSaving, setIsSaving] = React.useState(false);
  const [reason, setReason] = React.useState('');

  const onSave = async (e) => {
    e.preventDefault();
    setIsSaving(true);
    const reasonForException ={
      description: {
        blob: reason,
        editorType: 'MARKDOWN',
      },
    };
    await onCancelEvent(
        event.clientRn,
        event.eventRn,
        reasonForException,
        () => {
          closeModel(true);
        },
    );
  };

  const onClose = () => {
    closeModel(false);
  };

  return (
    <Dialog onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle onClose={onClose}>
        <Translate expression='eventList.CancelEvent.Title'/>
      </DialogTitle>
      <DialogContent>
        <Typography>
          <Translate expression='eventList.CancelEvent.CancelConfirm'/>
        </Typography>
        <TextField
          label={<Translate expression='eventList.Reason.Reason'/>}
          value={reason}
          onChange={(e) => setReason(e)}
          multiline
          rows={3}
          fullWidth
          margin="normal"
          placeholder={translate('eventList.Reason.ReasonForCancel')}
        />
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose}>
          <Translate expression='eventList.eventDetail.cancel'/>
        </Button>
        <Button onClick={onSave} disabled={isSaving}>
          <Translate expression='eventList.CancelEvent.confirm' />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

CancelEvent.propTypes = {
  closeModel: PropTypes.func.isRequired,
  event: PropTypes.object.isRequired,
  onCancelEvent: PropTypes.func.isRequired,
};

export default CancelEvent;
